<template>
  <div>
    <h1>Productos</h1>
    <p>Estado: {{ productos.length }} productos cargados</p>
    <v-row>
      <v-col
        v-for="producto in productos"
        :key="producto.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card class="mx-auto text-center" max-width="300" color="#f6f6f6">
          <v-img
            :src="urlImagen(producto.imagen)"
            height="180"
            class="imagen-producto"
            :alt="producto.nombre"
            contain
          ></v-img>
          <v-card-title class="justify-center titulo-card">
            {{ producto.nombre }}
          </v-card-title>
          <v-card-subtitle class="text-caption py-1 descripcion-producto">
            {{ producto.descripcion }}
          </v-card-subtitle>
          <v-card-text>
            <div><strong>Precio:</strong> {{ producto.precio }}</div>
            <div><strong>Stock:</strong> {{ producto.stock }}</div>
            <div><strong>Categoría:</strong> {{ producto.categoria }}</div>
          </v-card-text>
          <v-card-actions class="justify-center pt-1 pb-1">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="editarProducto(producto)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="success" v-bind="attrs" v-on="on" @click="abrirDialogoStock(producto)">
                  <v-icon>add_shopping_cart</v-icon>
                </v-btn>
              </template>
              <span>Agregar stock</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
    >
      {{ mensaje.texto }}
    </v-snackbar>
    <v-btn 
      fab x-large elevation="8" 
      color="#ffd600" 
      fixed right bottom
      @click="abrirDialogoNuevoProducto">
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="mostrarDialogo" persistent max-width="600px">
      <form-producto :producto="nuevoProducto" @cerrado="cerrarDialogo" @registrar="registrarProducto" />
    </v-dialog>
    <v-dialog v-model="mostrarDialogoStock" persistent max-width="400px">
      <v-card>
        <v-card-title>
          Agregar Stock - {{ productoSeleccionado ? productoSeleccionado.nombre : '' }}
        </v-card-title>
        <v-card-text v-if="productoSeleccionado">
          <v-text-field
            v-model.number="cantidadStock"
            label="Cantidad a agregar"
            type="number"
            min="1"
            :rules="[v => v > 0 || 'Cantidad mayor a 0']"
            required
          />
          <p><strong>Stock actual:</strong> {{ productoSeleccionado.stock }}</p>
          <p><strong>Stock después de agregar:</strong> {{ productoSeleccionado.stock + cantidadStock }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cerrarDialogoStock">
            Cancelar
          </v-btn>
          <v-btn color="success" @click="agregarStock">
            Agregar Stock
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarDialogoEliminar" persistent max-width="400px">
      <!-- Diálogo de eliminar eliminado por solicitud del usuario -->
    </v-dialog>
  </div>
</template>
<script>
import Utiles from '../../Servicios/Utiles'
import FormProducto from './FormProducto.vue'
import HttpService from '../../Servicios/HttpService'
export default {
  name: "Productos",
  components: { FormProducto },
  data: () => ({
    productos: [],
    encabezadoTabla: [
      { text: "ID", value: "id", sortable: true },
      { text: "Nombre", value: "nombre", sortable: true },
      { text: "Descripción", value: "descripcion", sortable: true },
      { text: "Precio", value: "precio", sortable: true },
      { text: "Stock", value: "stock", sortable: true },
      { text: "Categoría", value: "categoria", sortable: true },
      { text: "Imagen", value: "imagen", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    mostrarDialogo: false,
    mostrarMensaje: false,
    mensaje: {
      texto: '',
      color: ''
    },
    nuevoProducto: {
      nombre: '',
      descripcion: '',
      precio: '',
      stock: '',
      categoria: '',
      imagen: null
    },
    mostrarDialogoStock: false,
    productoSeleccionado: null,
    cantidadStock: 1,
    mostrarDialogoEliminar: false,
    productoAEliminar: null
  }),
  mounted() {
    console.log('Componente Productos montado');
    this.cargarProductos();
  },
  methods: {
    urlImagen(imagen) {
      // Si no hay imagen, usar la imagen por defecto
      if (!imagen) {
        return '/api/imagenes/default.jpg';
      }
      return Utiles.generarURL(imagen);
    },
    abrirDialogoNuevoProducto() {
      this.nuevoProducto = {
        nombre: '',
        descripcion: '',
        precio: '',
        stock: '',
        categoria: '',
        imagen: null
      };
      this.mostrarDialogo = true;
    },
    cerrarDialogo() {
      this.mostrarDialogo = false;
    },
    cargarProductos() {
      console.log('Cargando productos...');
      HttpService.obtenerConDatos({metodo: 'obtener'}, 'productos.php').then(productos => {
        console.log('Productos cargados:', productos);
        this.productos = productos;
      }).catch(error => {
        console.error('Error al cargar productos:', error);
        this.mostrarMensaje = true;
        this.mensaje = { texto: 'Error al cargar productos', color: 'error' };
      });
    },
    registrarProducto(producto) {
      // Convertir imagen a base64 si es archivo
      const datos = { ...producto };
      const esEdicion = !!datos.id;
      
      if (datos.imagen && typeof datos.imagen !== 'string' && datos.imagen instanceof File) {
        // Nueva imagen seleccionada - convertir a base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          datos.imagen = e.target.result;
          const payload = { metodo: esEdicion ? 'actualizar' : 'registrar', producto: datos };
          const res = await HttpService.registrar(payload, 'productos.php');
          this.procesarRespuestaRegistro(res, esEdicion);
        };
        reader.readAsDataURL(datos.imagen);
      } else {
        // Sin imagen nueva - enviar datos sin procesamiento de imagen
        if (esEdicion) {
          // En edición, si no hay imagen nueva, no enviar el campo imagen
          if (!datos.imagen || datos.imagen === null) {
            delete datos.imagen; // Eliminar campo para mantener imagen actual
          }
        }
        const payload = { metodo: esEdicion ? 'actualizar' : 'registrar', producto: datos };
        HttpService.registrar(payload, 'productos.php').then(res => {
          this.procesarRespuestaRegistro(res, esEdicion);
        });
      }
    },
    procesarRespuestaRegistro(res, esEdicion = false) {
      if (res) {
        this.mostrarMensaje = true;
        this.mensaje = { texto: esEdicion ? 'Producto editado correctamente' : 'Producto registrado correctamente', color: 'success' };
        this.cerrarDialogo();
        this.cargarProductos();
      } else {
        this.mostrarMensaje = true;
        this.mensaje = { texto: esEdicion ? 'Error al editar el producto' : 'Error al registrar el producto', color: 'error' };
      }
    },
    editarProducto(producto) {
      this.nuevoProducto = { ...producto };
      // Limpiar el campo imagen para el input de archivo
      // El campo imagen del producto editado contiene la ruta actual, no el archivo
      this.nuevoProducto.imagenActual = producto.imagen; // Guardar referencia de imagen actual
      this.nuevoProducto.imagen = null; // Limpiar para el input de archivo
      this.mostrarDialogo = true;
    },
    abrirDialogoStock(producto) {
      this.productoSeleccionado = producto;
      this.cantidadStock = 1;
      this.mostrarDialogoStock = true;
    },
    cerrarDialogoStock() {
      this.mostrarDialogoStock = false;
    },
    agregarStock() {
      const payload = {
        metodo: 'actualizar',
        producto: {
          ...this.productoSeleccionado,
          stock: this.productoSeleccionado.stock + this.cantidadStock
        }
      };
      HttpService.registrar(payload, 'productos.php').then(res => {
        if (res) {
          this.mostrarMensaje = true;
          this.mensaje = { texto: 'Stock actualizado correctamente', color: 'success' };
          this.cerrarDialogoStock();
          this.cargarProductos();
        } else {
          this.mostrarMensaje = true;
          this.mensaje = { texto: 'Error al actualizar el stock', color: 'error' };
        }
      });
    },
    eliminarProducto(producto) {
      // Función eliminada por solicitud del usuario
    },
    cerrarDialogoEliminar() {
      // Función eliminada por solicitud del usuario
    },
    confirmarEliminar() {
      // Función eliminada por solicitud del usuario
    }
  }
}
</script> 
<style scoped>
.descripcion-producto {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin: 0 auto;
  display: block;
}
.titulo-card {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin: 0 auto;
  display: block;
}
.imagen-producto {
  object-fit: contain !important;
  background: #ffffff;
  width: 100%;
  height: 180px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 


// WEBPACK FOOTER //
// src/components/Productos/Productos.vue